import {
  getStyle
} from '../../config/mUtils'
import {
  imgBaseUrl,
  ssoUrl,
  cvoUrl,
} from '../../config/env'
import util from '../../config/util'
import store from '@/store/'
import { pc_pv_threshold } from '@/common/constant'
export const cartAnimation = {
  data() {
    return {
      receiveInCart: false, //购物车组件下落的圆点是否到达目标位置
      showMoveDot: [], //控制下落的小圆点显示隐藏
      animationImg: null, //动画图片
      windowHeight: null, //屏幕的高度
      windowWidth: null, //屏幕的宽度
      elLeft: 0, //当前点击加按钮在网页中的绝对top值
      elBottom: 0, //当前点击加按钮在网页中的绝对left值
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
  },
  methods: {
    //显示下落圆球
    showMoveDotFun(showMoveDot, elLeft, elBottom, src) {
      this.showMoveDot = [...this.showMoveDot, ...showMoveDot];
      this.elLeft = elLeft;
      this.elBottom = elBottom;
      this.animationImg = src;

    },
    beforeEnter(el) {
      el.style.transform = `translate3d(0,${this.elBottom - 330}px,0)`;

      let offsetX = this.elLeft - this.windowWidth + 70
      if (this.rightOpen) {
        offsetX = this.elLeft - this.windowWidth + 390
      }
      el.children[0].style.transform = `translate3d(${offsetX}px,0,0)`;
      el.children[0].style.opacity = 0;
    },
    afterEnter(el) {
      el.style.transform = `translate3d(0,0,0)`;
      el.children[0].style.transform = `translate3d(0,0,0) scale(0.3)`;
      el.style.transition = 'transform .55s ease-out';
      el.children[0].style.transition = 'transform .55s linear';
      this.showMoveDot = this.showMoveDot.map(item => false);
      el.children[0].style.opacity = 1;
      el.children[0].addEventListener('transitionend', () => {
        this.listenInCart();
      })
      el.children[0].addEventListener('webkitAnimationEnd', () => {
        this.listenInCart();
      })
    },
    //监听圆点是否进入购物车
    listenInCart() {
      if (!this.receiveInCart) {
        this.receiveInCart = true;
        console.log(this.$refs.cartContainer)
        this.$refs.cartContainer.addEventListener('animationend', () => {
          this.receiveInCart = false;
        })
        this.$refs.cartContainer.addEventListener('webkitAnimationEnd', () => {
          this.receiveInCart = false;
        })
      }
    },
  }
}

export const promoteMethods = {
  data() {
    return {
      promote_code: null, //记录减免Code
      promoteList: [], //促销集合
      free: 0,
    }
  },
  methods: {
    pushProduct(arr,item){
      arr.push({
          attrs: [],
          extra: {},
          id: 0,
          name: item.name,
          packing_fee: "",
          price: item.price,
          pt: item.pt,
          pv: item.pv,
          point: 0,
          amount: item.price * item.num, //现金支付金额
          ar_value: 0, //AR支付金额
          num: item.num, //数量(个数)，point支付和 amount支付总计个数
          sku_id: item.gift_value,
          sku: item.gift_value,
          specs: item.specification,
          stock: "",
          selected: "",
          spec_code: item.promote_code,
          spec_name: item.promote_name,
          product_flag: 1,
          specification: item.specification,
          Url: item.image_path_big
        });
    },
    CxList() {
      let newArr = new Array();
      Object.values(this.promoteList).forEach(item => {
        if (item.control <= 1) {
          return false;
        }
        if (item.promote_mode != 'combine') {
          this.pushProduct(newArr,item)
        } else {
          item.optionals.filter(item1=>item1.num != 0).forEach(item1=>this.pushProduct(newArr,item1))
        }
        
      });
      return newArr;
    },

    IsPromoteTip(sku, num) //促销文字提示
    {
      if (!this.promote || !this.promote.value || !this.cartInfo.value) return false;
      var tip = '';
      var car_model = this.cartInfo.value;
      var store_id = this.default_store_id;
      const filterdPromote = this.promote.value.filter(item=>{
        if (item.other_rules && item.other_rules.indexOf('notincludeskus') != -1) {
          let skus = item.other_rules.split('|')
                      .find(rule=>rule.indexOf('notincludeskus') != -1)
                      .replace('notincludeskus-','').split(',')
          var products = this.shopCartList().filter(
                u =>skus.indexOf(u.sku.toLowerCase()) != -1
              );
          if (products.length) return false

        }
        return true
      })
      filterdPromote.forEach((item, index) => {
        let gift_type = item.detail[0].gift_type.toLowerCase()
        if (gift_type != 'express' && gift_type != 'pt') {
          var istore_id = item.store_id.filter(u => u.store_id == store_id);
          if (!istore_id[0] || istore_id.findIndex(i=>i.stock > 0) == -1) {
            return false;
          }

        }
        if (item.threshold == 0) { //不提示
          return false;
        }
        if (item.include_ar == -1 && car_model.ar_value > 0) {
          return false;
        }
        if (item.include_servicefee == -1 && car_model.service_fee > 0) {
          return false;
        }
        switch (item.limit_type.toLowerCase()) {
          case 'pt':
            if (car_model.total_change_point >= item.threshold && car_model.total_change_point < item.limit_value) {
              tip += (item.th_description || '').replace('{0}', (item.limit_value - car_model.total_change_point).toFixed(2));
            }
            break;
          case 'pv':
            if (car_model.total_pv >= item.threshold && car_model.total_pv < item.limit_value) {
              tip += (item.th_description || '').replace('{0}', (item.limit_value - car_model.total_pv).toFixed(2));
            }
            break;
          case 'cash':
            var product_amount = car_model.total_product_amount +
              (car_model.delivery_fee * item.include_expressfee) +
              (car_model.service_fee * item.include_servicefee) -
              (car_model.ar_value * item.include_ar) - (this.couponMoney || 0)
            if (product_amount >= item.threshold && product_amount < item.limit_value) {
              tip += (item.th_description || '').replace('{0}', (item.limit_value - product_amount).toFixed(2));
            }
            break;
          case 'sku':
            var skus = item.limit_value.toLowerCase().split(',');
            if (skus.indexOf(sku.toLowerCase()) != -1) {
              var products = car_model.detail.filter(
                u =>skus.indexOf(u.sku.toLowerCase()) != -1 && u.sku.toLowerCase() != sku.toLowerCase()
              );
              var dh = 0,number = 0;
              if (products[0]) {
                if (item.include_servicefee == 0) {
                  dh = products.reduce((prev,cur)=>cur.pt > 0 ? prev + cur.point / cur.pt:prev,0)
                }
                number = products.reduce((prev,cur)=> prev + cur.num,0) - dh;
              }

              //找到购买对应数量
              if (num + number >= item.threshold && num + number < item.per_num) {
                tip += (item.th_description || '').replace('{0}', item.per_num - (num + number));
              }
            }
            break;
        }
      })
      if (tip.trim() != '') {
        this.$Toast.show(tip, {
          duration: 3000,
          //position: 'top'
        });
        // this.$com.show(tip, 1000);
        return;
      }
    },
    loadpromoteList() {
      if (!this.promote || !this.promote.value || !this.cartInfo.value)
        return false;

      let promoteListArr = new Array();
      var car_model = this.cartInfo.value;
      this.free = 0;
      this.promote_code = null;
      var store_id = this.default_store_id;
      var lrp_flag = 0;
      //当购买生日套装 和 大会代码 特殊处理
      var birthdaydata = this.shopCart.filter(u => u.product_flag == 10);

      if (this.firstPromoCode) {
        var lrp_flag = 0;
        if (this.firstPromoCode.lrp_flag == 0) {
          lrp_flag = -2;
        }
        if (this.firstPromoCode.lrp_flag == 2) {
          lrp_flag = -1;
        }
      }
      // else if(birthdaydata[0]){
      // 	lrp_flag=-2;
      // }
      var copyPromote = JSON.parse(JSON.stringify(this.promote));
      if (lrp_flag != 0) {
        copyPromote.value = copyPromote.value.filter(
          u => u.order_type == 0 || u.order_type == lrp_flag
        );
      }

      var firstset = copyPromote.value.filter(
        u => u.other_rules == "notincludefirstset"
      );
      if (firstset[0]) {
        var limtModel = this.checkFirstSet();
        if (limtModel[0]) {
          copyPromote.value = copyPromote.value.filter(
            u => u.other_rules != "notincludefirstset"
          );
        }
      }

      var notothersku = copyPromote.value.filter(
        u => u.other_rules == "notothersku"
      );
      if (notothersku[0] && car_model.detail[0]) {
        var limtModel = car_model.detail.filter(u => u.sku != notothersku[0].limit_value)
        if (limtModel[0]) {
          copyPromote.value = copyPromote.value.filter(
            u => u.other_rules != "notothersku"
          );
        }
      }
      copyPromote.value = copyPromote.value.filter(item=>{
        if (item.other_rules && item.other_rules.indexOf('notincludeskus') != -1) {
          let skus = item.other_rules.split('|')
                      .find(rule=>rule.indexOf('notincludeskus') != -1)
                      .replace('notincludeskus-','').split(',')
          var products = this.shopCartList().filter(
                u =>skus.indexOf(u.sku.toLowerCase()) != -1
              );
          if (products.length) return false

        }
        return true
      })

      copyPromote.value.forEach((item, index) => {
        // if(item.store_id.indexOf(store_id)==-1){
        // 	return false;
        // }
        var istore_id = [];
        if (
          item.detail[0] &&
          (item.detail[0].gift_type.toLowerCase() == "express" || item.detail[0].gift_type.toLowerCase() == "pt")
        ) {} else {
          istore_id = item.store_id.filter(
            u => u.store_id == store_id
          );
          if (!istore_id[0]) {
            return false;
          }
        }
        if (item.include_ar == -1 && car_model.ar_value > 0) {
          return false;
        }
        if (
          item.include_servicefee == -1 &&
          car_model.service_fee > 0
        ) {
          return false;
        }
        switch (item.limit_type.toLowerCase()) {
          case "pt":
            if (car_model.total_change_point >= item.limit_value) {
              promoteListArr.push({
                item,
                istore_id,
                result: car_model.total_change_point /
                  item.limit_value
              });
            }
            break;
          case "pv":
            if (car_model.total_pv >= item.limit_value) {
              if (item.limit_value == "0") {
                promoteListArr.push({
                  item,
                  istore_id,
                  result: item.per_num
                });
              } else if (item.other_rules == 'firstsetonlyone') { 
                // 促销规则特殊处理，订单中含有首购最多只送一套
                let firstsetsSKU = this.checkFirstSet()
                let result = firstsetsSKU.length ? 1:car_model.total_pv / item.limit_value
                promoteListArr.push({
                  item,
                  istore_id,
                  result,
                });
                
              } else {
                promoteListArr.push({
                  item,
                  istore_id,
                  result: car_model.total_pv / item.limit_value
                });
              }
            }
            break;
          case "cash":
            var product_amount =
              car_model.total_product_amount +
              car_model.delivery_fee * item.include_expressfee +
              car_model.service_fee * item.include_servicefee -
              car_model.ar_value * item.include_ar - (this.couponMoney || 0);
            if (product_amount >= item.limit_value) {
              promoteListArr.push({
                item,
                istore_id,
                result: product_amount / item.limit_value
              });
            }
            case "sku":
              var skus = item.limit_value.toLowerCase().split(',');
              var products = this.shopCartList().filter(
                u =>skus.indexOf(u.sku.toLowerCase()) != -1
              );
              if (products[0]) {
                var dh = 0;
                if (item.include_servicefee == 0) {
                  dh = products.reduce((prev,cur)=>cur.pt > 0 ? prev + cur.point / cur.pt:prev,0)
                }
                var number = products.reduce((prev,cur)=> prev + cur.num,0) - dh;
                if (number >= item.per_num) {
                  promoteListArr.push({
                    item,
                    istore_id,
                    result: number / item.per_num
                  });
                }
              }
              break;
        }
      });
      var promoteListNew = promoteListArr;
      if (promoteListArr.length > 1) {
        var no_superposition = promoteListArr.filter(
          u => u.item.is_superposition == 0
        );
        if (no_superposition[0]) {
          var a = no_superposition.sort(function (a, b) {
            return a.item.priority - b.item.priority;
          });
          promoteListNew = promoteListNew.filter(u => u.item.is_superposition != 0);
          promoteListNew.push(a[0]);
        }
      }
      let promoteList = [];
      promoteListNew.forEach((item, index) => {
        promoteList.push(
          ...this.givepromoteList(
            item.item,
            item.istore_id,
            item.result
          )
        );
      });
      this.promoteList = promoteList
    },
    givepromoteList(model, istore_id, result) {
      var obj = new Array();
      result = parseInt(result);
      if (isNaN(result)) {
        result = 1;
      }
      model.detail.forEach((item, index) => {
        switch (item.gift_type.toLowerCase()) {
          case "sku":
            //验证库存
            var product = istore_id.filter(
              u => u.sku.toLowerCase() == item.sku.toLowerCase()
            );
            item.control = -1;

            if (product[0]) {
              var control = product[0].control; //item.sku=='49361912'?1:product[0].control;
              if (control > 1) {
                //--无库存不显示
                //console.error(model)
                var number = 0;
                if (model.max_num <= 0) {
                  var max_result =
                    item.max_num -
                    item.cust_current_giftskunum;

                  max_result =
                    max_result <= 0 ? 0 : max_result;
                  number =
                    result >= max_result ?
                    max_result :
                    result;
                } else {
                  number =
                    result >= model.max_num ?
                    model.max_num :
                    result;
                }
                if (number <= product[0].stock) {
                  //正常 2
                  item.control = 2;
                } else {
                  item.control = 20;
                  number = 0;
                }
                item.num = number;
                if(model.promote_mode == 'combine') {
                  let lastSelected = this.combinePromote
                  let opt_total = item.optionals.reduce((prev,cur)=>{
                      let cur_num = 0
                      if(lastSelected[model.code] && lastSelected[model.code][cur.sku]) cur_num = lastSelected[model.code][cur.sku]
                      let stock = cur.store_id.filter(item=>item.store_id == this.default_store.Code)[0] || {}
                      if (stock.stock < cur_num) cur_num = 0
                      return prev + cur_num
                  },0)
                  if(opt_total == number && number != 0) {
                      item.optionals.forEach(optional=>optional.num = lastSelected[model.code][optional.sku] || 0)
                  }
                    
                }
                
              } else {
                item.control = control;
              }
            }
            obj.push({...item,isNoThreshold: model.other_rules?.indexOf('noreason') >= 0, valid_from: model.valid_from, valid_to: model.valid_to});
            break;
          case "express":
            //if (this.deliveryFee > 0) {
            this.free = Number(item.gift_value);
            this.setOtherCar();
            item.control = -1; //禁止显示
            obj.push(item);
            //}
            this.promote_code = item.promote_code;
            break;
          case "pt":
            item.control = -1; //禁止显示
            obj.push(item);
            break;
        }
      });
      return obj;
    },
  }
}
export const charitableMethods = {
  computed: {
    charitableList: function () {
      if (this.charitable.result) {
        let list1 = this.charitable.list || [];
        let list = list1.map(item => item.list);
        return Array.prototype.concat.apply([], list);
      }
      return [];
    },
  },
  methods: {
    checkBuyCart: function (ll) {
      let buy_charitable = false;
      if (this.charitableList[0]) {
        for (const index in ll) {
          if (this.charitableList.filter(u => u.SKU == ll[index].sku)[0]) {
            buy_charitable = true;
            break;
          }
        }
      } else {
        buy_charitable = true;
      }
      return buy_charitable
    }
  }
}
export const productLimtMethods = {
  computed: {
    SkuLimt: function () {
      let ret = [...((this.productLimt || {}).value || [])];
      return ret;
    },
    productLimit: function () {
      let pl = this.SkuLimt.filter(u => u.sku == this.product.sku || u.sku.toLowerCase() == 'all');
      return pl;
    },
    productPTLimit: function () {
      let pl = this.productLimit.filter(function (item) {
        return item.limit_type == "PT";
      });
      return pl;
    },
    productAddCost:function(){
			let pl = this.SkuLimt.filter((u) => u.limit_sku == this.product.sku);
			return pl;
		},
    productFlash:function(){
			let pl = this.SkuLimt.filter((u) => u.sku == this.product.sku&&u.limit_type=='Flash');
			return pl;
		},
    productFlash:function(){
      let pl = this.SkuLimt.filter((u) => u.sku == this.product.sku&&u.limit_type=='Flash');
      return pl;
    },

    //需要隐藏的产品
    hiddenSKUs:function(){
      let skus = {}
      this.SkuLimt.filter((u) => u.limit_type == 'Visibility' && u.max_num <= 0).forEach(item=>skus[item.sku] = 1);
      return skus
    }
  },
  methods: {
    getProductFlash(sku) {
        let pl = (this.SkuLimt||[]).filter((u) => u.sku == sku&&u.limit_type=='Flash');
        return pl;
    },
    isPTLimit(sku) {
      let pl = this.productPTLimit.filter((u) => u.sku == sku);
      return pl.length >= 1;
    },
    showLevelLimitModal(){
      if (!this.userInfo) {
        this.$CModal.show({
          title:'提示(Tip)',
          content:'<p>BOGO仅限优惠顾客购买，请先注册为优惠顾客。</p><p>BOGO for preferred customer only, please register preferred customer at first.</p>',
          okText:'<p>已注册,去登录</p><p>Login</p>',
          cancelText:'<p>去注册</p><p>Go to register</p>',
          onOk:()=>{
            location.href = `${ssoUrl}/sso/index.html#/login`;
          },
          onCancel:()=>{
            location = `${cvoUrl}/vo/index.html#/enroll/create?level=pc&from=WebSite`
          }
        })
        return;
      }
      this.$CModal.show({
        title:'提示(Tip)',
        content:'<p>BOGO仅限优惠顾客购买，请先升级优惠顾客。</p><p>BOGO for preferred customer only, please upgrade as preferred customer..</p>',
        okText:'<p>升级优惠顾客</p><p>upgrade preferred customer</p>',
        onOk:()=>{
          location.href = `${cvoUrl}/vo/index.html#/enroll/appendPcInfo?token=${this.getAccessToken}&source=WebSite`;
        },
      })
    }
  }
}

export const userInfoOrderMethods = {
  data() {
    return {}
  },
  computed: {
    useInfoSwitch: function () {
      if (this.getVipNo) {
        return {
          ...(((this.userInfo || {}).value || {}))
        }
      } else {
        return {
          ...(((this.guestInfo || {}).value || {}))
        }
      }
    },
    default_store: function () {
      let ui = this.useInfoSwitch.binding || {}
      if (ui.default_store_id) {
        return {
          Code: ui.default_store_id,
          Name: ui.default_store_name,
          NameEn: ui.default_store_nameen,
        }
      } else {
        var model = this.warehouseList.filter(u => u.Code == '501')[0];
        if (model) {
          return {
            ...model
          }
        }
      }
      return {}
    },
    default_store_id: function () {
      return this.default_store.Code || '501';
    },
    switchOrder: function () {
      let data = this.useInfoSwitch;
      let ui = data.binding || {};
      if (ui.customer_type) {
        var register = ui.register || {};
        if (ui.customer_type.toLowerCase() == 'rt' || ui.first_order_status == 0 || register.lrp_flag == 1 || data.lrp_id) {
          if (this.newcustomer && register.lrp_flag == 1 && !data.lrp_id) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },
    newcustomer: function () {
      let ui = {
        ...(((this.userInfo || {}).value || {}).binding || {})
      };
      if (ui.catalog) {
        if (ui && ui.catalog.toLowerCase() == 'lrp') {
          return true;
        }
      }
      return false;
    },
    isOriginalPrice: function () {
      let ui = {
        ...(((this.userInfo || {}).value || {}).binding || {})
      };
      if (ui.customer_type) {
        if (this.forCustomer) {
          if (this.forCustomer.customer_type == 'rt') return true
        } else if (ui.customer_type && ui.customer_type.toLowerCase() == 'rt') {
          return true;
        }
        return false;
      }
      return true;
    },
    selfCarNo: function () {
      let ui = {
        ...(((this.userInfo || {}).value || {}).binding || {})
      };
      if (ui && ui.register && ui.register.id_card) {
        return true;
      }
      return false;
    },
    isPVOriginalPrice: function () {
      if (this.isOriginalPrice) { //如果是rt 满足pc_pv_threshold
        if (!this.selfCarNo) return true
        if (this.payPv < pc_pv_threshold) return true
      }
      return false;


    },
    isFirstOrder: function () {
      let ui = {
        ...(((this.userInfo || {}).value || {}).binding || {})
      };
      if (ui && ui.first_order_status == 0) {
        return true;
      }
      return false;
    },

  },
}
export const systemConfigMethods = {
  data() {
    return {

    }
  },
  computed: {
    systemDetail: function () {
      return this.sysConfig.value
    },

  }
}
export const cartInfoMethods = {
  data() {
    return {

    }
  },
  computed: {
    payPv: function () {
      let car = (this.cartInfo || {}).value || {};
      return car.total_pv || 0;
    },
    //配送费
    baseDeliveryFee: function () {
      let df = 0;
      if (this.default_store_id == '501') {
        df = (Number(this.systemDetail.float_delivery_fee) || 15);
      }
      return df;
    },
    //服务费
    baseServiceFee: function () {
      let df = 0;
      var float_service_fee = Number(this.systemDetail.float_service_fee) || 0;
      this.shopCart.forEach(item => {
        if (item.point > 0) df = float_service_fee
      });
      return df; //.toFixed(2);
    },
    //当前商店购物信息
    shopCart: function () {
      return (((this.cartInfo || {}).value || {}).detail || []);
    },
    cartCount: function () {
      let number = 0;
      this.shopCart.forEach((item, index) => {
        number += item.num
        item.additionals?.forEach(item1=>number += item1.num)
      })
      return number;
    },
    cartPrice: function () {
      return ((this.cartInfo || {}).value || {});
    },
    lrpProductLimit: function () {
      var pv = 0;
      this.shopCart.forEach((item, index) => {
        if (item.is_lrpt_product != 20 && item.num > 0) {
          pv += item.pv * item.num;
        }
      })
      return pv;
    },
  },
  methods: {
    getLRPType(type) {
      //检测某类型产品是否存在
      var res = this.shopCart.filter(u => u.is_lrpt_product == type && u.num > 0);
      return res;
    },
    checkFirstSet() {
      let model = [];
      this.shopCart.forEach(item => {
        if (item.num > 0 && this.cartCheck[item.sku]) {
          let matched = this.SkuLimt.find(u => u.limit_type == "FirstSet" && item.sku == u.sku);
          if (matched) model.push(matched)
        }
      });
      return model;
    },
    getFirstSet(){
      return this.SkuLimt.filter(u => u.limit_type == "FirstSet");
    }


  }
}

export const promoCodeMethods = {
  computed: {
    isewPromoCode: function () {
      var IsObj = Object.getOwnPropertyNames(this.newpromoCode).length;
      if (IsObj > 1) return true;
      return false;
    },
    firstPromoCode: function () {
      var Promosku = null;
      var PromoCodeitem = null;
      Object.values(this.newpromoCode).forEach(item => {
        Promosku = item
      })
      if (Promosku) {
        Object.values(Promosku).forEach(item => {
          PromoCodeitem = item
        })
      }
      return PromoCodeitem;
    },
    firstOpentoAll: function () {
      var item = this.firstPromoCode;
      if (item && item.is_opentoall == 0) {
        return item
      }
      return null;
    },
    Promodisplacer: function () {
      if (this.firstPromoCode) {
        return this.firstPromoCode.displacer_flag == 0 ? false : true;
      }
      return true
    },
    PromoAR: function () {
      if (this.firstPromoCode) {
        return this.firstPromoCode.ar_flag == 0 ? false : true;
      }
      return true
    },
    PromoPT: function () {
      if (this.firstPromoCode) {
        return this.firstPromoCode.pt_flag == 0 ? false : true;
      }
      return true
    },
  },
  methods: {
    getBySkuPromoCode(sku) {
      return this.newpromoCode[sku] || {}
    },
    getBySkufirstPromoCode(sku) {
      var PromoCodeitem = null;
      var data = this.getBySkuPromoCode(sku);
      Object.values(data).forEach(item => {
        PromoCodeitem = item
      })
      return PromoCodeitem
    },
    getBySkuJson(sku) {
      var data = this.getBySkuPromoCode(sku);
      if (data) {
        var params = []
        Object.values(data).forEach(item => {
          params.push({
            sku: item.exchange_sku,
            code: item.promo_code,
            num: item.num
          })
        })
        return JSON.stringify(params)
      }
      return ''
    }

  }
}

export const addressMethods = {
  data() {
    return {
      addresses: [],
      editAddress: {
        id: 0,
        name: null,
        province_id: null,
        moblie_phone: null,
        city_id: null,
        county_id: null,
        town_id: null,
        street: null,
        zip: null,
        is_default: '0',
        tag_type: '0',
        address_type: '1',
      },
      show: false,
      loading: false,
    }
  },
  methods: {
    // 编辑地址
    addAddress() {
      let address_type = this.addresses.length ? 1:0
      let is_default = this.addresses.length ? false:true
      let moblie_phone = this.userInfo?.value?.binding?.moblie_phone
      this.editAddress = {
        id: 0,
        name: null,
        province_id: null,
        moblie_phone,
        city_id: null,
        county_id: null,
        town_id: null,
        street: null,
        zip: null,
        is_default,
        tag_type: 0,
        address_type,
      }
      this.show = true;
    },
    async asyncOK(address) {
      this.loading = true;
      var obj = {
        Id: address.id,
        Name: address.name.trim().replaceIllegalCode(),
        MobliePhone: address.moblie_phone,
        Province: address.province_id,
        City: address.city_id,
        County: address.county_id,
        Town: address.town_id,
        Street: address.street.replaceIllegalCode(),
        Zip: address.zip,
        AddressType: address.address_type,
        Tags: address.tag_type,
        IsDefault: address.is_default ? 1 : 0,
        CustomerId: this.userInfo.value.binding.user_id,
        Remark: '',
      };
      await this.postAddAddressAction(obj)
      await this.getWechatUserInfoAction();
      this.addresses = this.userInfo.value.binding.address;
      if (address.is_default && !this.choosedAddress && this.CHOOSE_ADDRESS) {
        let filAddress = this.addresses.filter(item=>item.is_default == 1)[0]
        if (filAddress)this.CHOOSE_ADDRESS({address: filAddress,index: 0,})
      }
      if (this.pickResolve) {
        this.pickResolve(address,true)
        this.pickResolve = null
      }
      this.show = false;
      this.loading = false;

    },
    setDefault(address) {
      let obj = Object.assign({}, address)
      obj.is_default = true
      this.asyncOK(obj)
    },
    modifyAddress(address) {

      this.editAddress = {
        id: address.id,
        name: address.name,
        province_id: parseInt(address.province_id),
        city_id: parseInt(address.city_id),
        county_id: parseInt(address.county_id),
        town_id: parseInt(address.town_id),
        street: address.street,
        zip: address.zip,
        moblie_phone: address.moblie_phone,
        address_type: address.address_type,
        tag_type: address.tag_type,
        is_default: address.is_default ? true : false,
      }
      this.show = true;
    },
    deleteAddress(address) {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '确定删除？',
          content: '确定要删除该地址吗<br />Are you sure you want to delete the address',
          onOk: async () => {
            let response = await this.delAddressAction(address.id);
            if (response >= 1) {
              this.addresses = [...this.addresses.filter(item => item.id != address.id)];
              resolve(true)
            } else {
              resolve(false)
            }
          }
        })
      })

    },
    IconText(name) {
      switch (name) {
        case '0':
          return null;
        case '1':
          return '家(Family)';
        case '2':
          return '学校(School)';
        case '3':
          return '公司(Company)';

      }
    },
    //地址备注颜色
    iconColor(name) {
      switch (name) {
        case '0':
          return '#4cd964';
        case '1':
          return '#9C27B0';
        case '2':
          return '#3190e8';
        case '3':
          return '#3190e8';
      }
    },
  }
}

export const formValid = {
  methods: {
    validate(name) {
      let _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs[name].validate((valid) => {
          resolve(valid)
        })
      })
    },
  }
}
export const getImgPath = {
  methods: {
    //传递过来的图片地址需要处理后才能正常使用
    getImgPath(path) {
      let suffix;
      if (!path) {
        return 'data:image/png;base64,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'
      }
      if (path.indexOf("http://") != -1 || path.indexOf("https://") != -1) {
        return path;
      } else {
        return imgBaseUrl + path;
      }
      /*
      if (path.indexOf('jpeg') !== -1) {
      	suffix = '.jpeg'
      } else {
      	suffix = '.png'
      }
      let url = '/' + path.substr(0, 1) + '/' + path.substr(1, 2) + '/' + path.substr(3) + suffix;
      return imgBaseUrl + url
      */
    },
  }

};
// 优惠券混入代码
export const couponsMixin = {
  data() {
      return {
        coupons:{},
        usedCouponCodes:[],
        couponMoney:0,
      }
  },
  watch:{
    'cartInfo.value.total_price'(cur,old){
      this.autoCheckCoupons()
      this.recalcCoupons()
    },
    deliveryFee(){
      this.autoCheckCoupons()
      this.recalcCoupons()
    },
  },
  computed: {
    showCoupons(){
      return this.validCoupons.length > 0
    },
    couponsDef(){
      let def = {}
      this.coupons?.couponDefines?.forEach(item=>def[item.key] = item.value)
      return def
    },
    validCoupons(){
      let validCoupons = []
      let now = util.realNowTime()
      if (!this.coupons) return []
      this.coupons?.couponList?.forEach((item, index) => {
        let valid = item.detailList.filter(item1=>{
            let def = this.couponsDef[item.code]
            return item1.useFlag == 0 
            && Date.fromStr(item1.validFrom) <= now 
            && Date.fromStr(item1.validTo) > now
            && def
            && Date.fromStr(def.validFrom) <= now 
            && Date.fromStr(def.validTo) > now
            && (def.channel.length == 0 || def.channel.indexOf('WebSite') != -1)
          }).map(item1=>{
          item1.code = item.code
          return item1
        })
        validCoupons = [...validCoupons,...valid]
      });
      return validCoupons
    },
  },
  methods:{
    // 订单金额变化时，重新计算优惠券
    recalcCoupons(){
      if (this.usedCouponCodes && this.usedCouponCodes.length) {
        let usedCouponCodes = [...this.usedCouponCodes], //已选中的券
            couponMoney = this.couponMoney, //券抵扣的金额
            length = this.usedCouponCodes.length,
            payFee = parseFloat(this.cartInfo?.value?.total_price) + parseFloat(this.deliveryFee); //加上积分兑换的金额以计算可使用券的金额
        for (let i = 0; i < length;i ++){
          let couponCode = this.usedCouponCodes[length - i - 1]
          let usedLimit = usedCouponCodes.reduce((prev,couponCode)=>{
            let curCoupon = this.validCoupons.find(item=>item.couponCode == couponCode)
            return prev + this.couponsDef[curCoupon.code].perNum
          },0), //已使用券抵扣的限制金额
          coupon = this.validCoupons.find(item=>item.couponCode == couponCode);
          let def = this.couponsDef[coupon.code] //券的规则定义
          if (def.limitValue > payFee + coupon.validValues - couponMoney || def.limitValue > payFee + def.perNum - usedLimit) {
            usedCouponCodes.pop(coupon.couponCode)
            couponMoney -= coupon.validValues
          } else {
            break;
          }
        }
        this.couponMoney = couponMoney
        this.usedCouponCodes = usedCouponCodes
            
      }
    },
    // 自动选择所有可用的优惠券
    autoCheckCoupons(){
      while (true) {
        if (!this.modifyCoupon(null,1,true)) break;
      }
    },
    /*
    value:当前值
    factor:步进值，-1/1
    noTip:是否隐藏提示
     */
    modifyCoupon(value,factor,noTip=false){
      if (factor > 0) {
        if (this.usedCouponCodes.length >= this.validCoupons.length) {
          if(!noTip){
            this.$Toast.show(`抱歉，您的优惠券已用完`, {
              duration: 5000,
            });
          }
          return false;
        }
        for (var i = 0;i < this.validCoupons.length;i++ ){
          let coupon = this.validCoupons[i];  //券
          let index = this.usedCouponCodes.findIndex(item=>item == coupon.couponCode)
          if (index == -1 && this.addCoupon(coupon,noTip)) return true; 
        }
        return false
      } else {
        // 移除最后一个券
        let couponCode = this.usedCouponCodes[this.usedCouponCodes.length - 1]
        let coupon = this.validCoupons.find(item=>item.couponCode == couponCode)
        this.removeCoupon(coupon)
      }
    },
    triggerCoupon({coupon,isChecked}) {
      if (!isChecked) {
        this.removeCoupon(coupon)
      } else {
        this.addCoupon(coupon)
      }
    },
    couponUseable(coupon) {
      let def = this.couponsDef[coupon.code], //券的规则定义
          usedLimit = this.usedCouponCodes.reduce((prev,couponCode)=>{
            let curCoupon = this.validCoupons.find(item=>item.couponCode == couponCode)
            return prev + this.couponsDef[curCoupon.code].perNum
          },0), //已使用券抵扣的限制金额
          couponMoney = this.couponMoney, //券抵扣的金额
          payFee = parseFloat(this.cartInfo?.value?.total_price) + parseFloat(this.deliveryFee); //加上积分兑换的金额以计算可使用券的金额
      if (def.limitValue <= payFee - couponMoney && def.limitValue <= payFee - usedLimit) {
        return true
      }
      return false
    },
    removeCoupon(coupon) {
      this.couponMoney -= coupon.validValues
      let usedCouponCodes = [...this.usedCouponCodes]
      usedCouponCodes.remove(coupon.couponCode)
      this.usedCouponCodes = usedCouponCodes
    },
    addCoupon(coupon,noTip=false) {
      let usedCouponCodes = [...this.usedCouponCodes], //已选中的券
          couponMoney = this.couponMoney //券抵扣的金额
      if (this.couponUseable(coupon)) {
        usedCouponCodes.push(coupon.couponCode)
        this.couponMoney += coupon.validValues
        this.usedCouponCodes = usedCouponCodes
        return true
      }
      if (!noTip) {
        let def = this.couponsDef[coupon.code];
        this.$Toast.show(`消费每满${def.perNum}元，即可使用1张电子优惠券`, {
          duration: 5000,
        });
      }
      
      return false
    },
    // 有剩余券且订单金额已满350，但已使用0张优惠券
    checkCoupons(){
      if (!(this.usedCouponCodes && this.usedCouponCodes.length)) {
        for (var i = 0;i < this.validCoupons.length;i++ ){
          let coupon = this.validCoupons[i];  //券
          if (this.couponUseable(coupon)) return true; 
        }
        return false
      }
    },
    confirmCoupon(usedCouponCodes){
      let validCoupons = this.validCoupons
      let couponMoney = usedCouponCodes.reduce((prev, couponCode) => {
        let curCoupon = validCoupons.find(item => item.couponCode == couponCode)
        return prev + curCoupon.validValues
      }, 0)
      this.couponMoney = couponMoney
      this.usedCouponCodes = [...usedCouponCodes]
    }
  },
}

export const observeMixin = {
  methods: {
    observe(Code){
      this.$nextTick(function() {
        document.querySelectorAll('[user-role="observer"]').forEach((element, index)=> {
          element.addEventListener('click', ()=>{
            store.dispatch('observeAction',{
              ButtonCode:element.getAttribute('download'),
              PageCode:Code,
            })
            let href = element.getAttribute('href')
            if (href) window.open(href)
          })
        });
      })
    }
  }
}

export const purchaseEventMethods = {
  methods: {
    needSaveTotalCart(sku,num){
      let needSaveTotalCart = false
      if (this.purchaseEvent && this.purchaseEvent[sku] && this.product.additionals) {
        let {defaultNum,perNum} = this.purchaseEvent[sku]
        let maxLimit = Math.floor(num * defaultNum / perNum)
        this.product.additionals.forEach(item=>{
          if(item.num > maxLimit) {
            item.num = maxLimit
            needSaveTotalCart = true
          }
        })
        if (needSaveTotalCart) {
          let cv = this.cartInfo.value;
          this.SET_CART_TOTAL({
            delivery_fee:cv.delivery_fee,
            service_fee:cv.service_fee,
            ar_value:cv.ar_value,
            ab_value:cv.ab_value,
          })
          let ll = this.shopCartList();
          
          let minCart = {
            id: cv.id,
            customer_id: this.userInfo.value.binding.user_id,
            store_id: this.default_store_id,
            address_id: 0,
            total_num: cv.num,
            total_price: cv.total_price,
            total_pv: cv.total_pv,
            total_change_point: cv.total_change_point,
            total_change_point_num: cv.total_change_point_num,
            total_product_amount: cv.total_product_amount,
            delivery_fee: cv.delivery_fee,
            service_fee: cv.service_fee,
            ar_value: cv.ar_value,
            pay_fee: cv.pay_fee,
            spec_code: null,
            detail: ll
          };
          this.saveCartAction({ minCart, type: false });
        }
      }
      return needSaveTotalCart
    },
    shopCartList() {
      const pushProduct = (item,product_flag) =>{
        if (item.is_hot == "1" && this.orderType != 0) {
          product_flag = 100;
        }
        var remark=null
        if(item.promo_code!=''&&item.promo_code){
          remark=this.getBySkuJson(item.sku)
        }

        newArr.push({
          attrs: [],
          extra: {},
          id: item.id,
          name: item.name,
          packing_fee: item.packing_fee,
          price: item.price,
          pt: item.pt,
          pv: item.pv,
          point: item.point,
          amount: item.amount, //现金支付金额
          ar_value: 0, //AR支付金额
          num: item.num, //数量(个数)，point支付和 amount支付总计个数
          sku_id: item.sku_id,
          sku: item.sku,
          specs: item.specs,
          stock: item.stock,
          selected: item.selected,
          spec_code: null,
          product_flag: product_flag,
          promo_code: item.promo_code,
          Url: null,
          remark:remark
        });
      }
      let newArr = new Array();
      this.shopCart.forEach(item => {
        if (item.num > 0) {
          var product_flag = item.is_lrpt_product || 0;
          pushProduct(item)
          if(item.additionals?.length) {
            item.additionals.forEach(item1=>pushProduct(item1,3))
          }
        }
      });
      return newArr;
    },
  }
}
